import { render, staticRenderFns } from "./riskEducation.vue?vue&type=template&id=70289b94"
import script from "./riskEducation.vue?vue&type=script&lang=js"
export * from "./riskEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70289b94')) {
      api.createRecord('70289b94', component.options)
    } else {
      api.reload('70289b94', component.options)
    }
    module.hot.accept("./riskEducation.vue?vue&type=template&id=70289b94", function () {
      api.rerender('70289b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskEducation.vue"
export default component.exports